import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Main from "./main";
import SideMenu from "./side-menu";
import SideMenuCollection from "../../collections/side-menu";

const channel = Radio.channel("global");

const DEFAULTS = {
  el: "#main-content",
  template: false,
  regions: {
    sideMenu: "#side-menu",
  },
};

class MainContent extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // instantiate main layout
    new Main();

    // instantiate side menu link collection, fetch and handle promise
    this.linkCollection = new SideMenuCollection();
    this.linkCollection
      .fetch()
      .done(this._onLinksLoaded.bind(this))
      .fail(this._onLinksLoadFailure.bind(this));
  }

  _onLinksLoaded() {
    // inject side menu view when its data has loaded
    this.sideMenu.show(
      new SideMenu({
        collection: this.linkCollection,
      })
    );
  }

  _onLinksLoadFailure() {
    // show error
    channel.trigger("status:show", {
      autoDismiss: false,
      type: "danger",
      message:
        "We were unable to load the main menu. Please notify your program manager.",
    });

    // console.warn("Side menu could not be loaded.");
  }
}

export { MainContent as default };
